import { ASYNC_FAIL, ASYNC_SUCCESS, ASYNC_MESSAGE_CLEAN } from '../actions'

const defaultState = {
  error: null,
  success: null
}

const messages = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ASYNC_SUCCESS: {
      // if (!payload.message) return state
      return {
        ...state,
        success: payload.message
      }
    }

    case ASYNC_FAIL: {
      // if (!payload.message) return state
      return {
        ...state,
        error: payload.message
      }
    }

    case ASYNC_MESSAGE_CLEAN: {
      return {
        ...state,
        warning: null,
        success: null,
        error: null
      }
    }

    default:
      return state
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/reducers/messages.js